import script from "./FirmarDocumento.vue?vue&type=script&setup=true&lang=js"
export * from "./FirmarDocumento.vue?vue&type=script&setup=true&lang=js"

import "./FirmarDocumento.vue?vue&type=style&index=0&id=e537fea6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e537fea6"]])

export default __exports__